module.exports = __webpack_public_path__ + "static/media/poulet-jerk.f669927c.png";